import { TimeSlot } from '../../types/model';
import { isRegistrationClosed, toTimestamp } from '../../utils';

function getFirstAvailableTimeSlot(timeSlots: TimeSlot[] | undefined) {
  if (!timeSlots) {
    return '';
  }

  const availableTimeSlot = timeSlots.find((t) => {
    const registrationClosedDateTimestamp = toTimestamp(
      t?.utcRegistrationClosedDate as number
    );
    if (isRegistrationClosed(registrationClosedDateTimestamp)) {
      return false;
    }

    if (t.remainingSpots === 0 && t.registerToWaitingList === false) {
      return false;
    }

    return true;
  });

  return availableTimeSlot?.timeslotId;
}

export default getFirstAvailableTimeSlot;
